module.exports = __webpack_public_path__ + "img/shopeepay-logo-horizontal-white.8a34ca50.png";